module.exports = __webpack_public_path__ + "media/memory-bank/location-pin-27ccb03a.png";